import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export default class PageTitleStrategy extends TitleStrategy {
    private readonly appName = 'Cosher';

    constructor(private readonly title: Title) {
        super();
    }

    override updateTitle(routerState: RouterStateSnapshot): void {
        const titleKey = this.buildTitle(routerState);
        const localized = titleKey
            ? abp.localization.localize(titleKey, 'RealtoCrm')
            : '';
        const pageTitle = localized && localized !== titleKey
            ? `${localized} | ${this.appName}`
            : this.appName;
        this.title.setTitle(pageTitle);
    }
}
